"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var utils_1 = require("../utils/utils");
function init() {
    var widgets = document.getElementsByClassName('laboratory-history-widget');
    if (widgets.length === 0)
        return;
    document.addEventListener('lgm.selected', function (event) {
        if (!(event instanceof CustomEvent))
            return;
        var history = (0, utils_1.get_first_element_by_class_or_null)(event.detail.element, 'history');
        if (!history)
            return;
        for (var i = 0; i < widgets.length; ++i) {
            var widget = widgets.item(i);
            if (!(widget instanceof HTMLElement))
                continue;
            var container = (0, utils_1.get_first_element_by_class_or_fail)(widget, 'laboratory-history-widget__container');
            container.innerHTML = "";
            var history_clone = history.cloneNode(true);
            history_clone.classList.remove('hidden');
            container.append(history_clone);
        }
    });
}
exports.init = init;
